(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.droopler_subtheme = {
    attach: function (context, settings) {

      $('.owl-carousel').owlCarousel({
        items: '1',
        loop: true,
        autoplay: true,
        autoplayHoverPause: true,
        nav: true,
        navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        dots: false
      });

    }
  };

})(jQuery, Drupal);
